import _WizardStepsCtrl from './_WizardStepsCtrl';
import templateStr from 'text!./templates/wizard-sidebar-ribbon.html';

export default function () {
    return {
        restrict: 'A',
        replace: true,
        template: templateStr,
        controller: _WizardStepsCtrl,
        scope: {
            title: '@'
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/wizard/WizardSidebarRibbonDirective.js
// module id = 792
// module chunks = 0